export const JWT_KEY = 'jwtToken';
export const JWT_EXPIRES_KEY = 'jwtExpiresAt';
export const MODULES_KEY = 'modulos';

const SESSION_KEYS = [JWT_KEY, JWT_EXPIRES_KEY, MODULES_KEY];

function migrateFromSessionStorage(key) {
  const legacy = sessionStorage.getItem(key);
  if (legacy !== null && legacy !== '') {
    localStorage.setItem(key, legacy);
    sessionStorage.removeItem(key);
    return legacy;
  }
  sessionStorage.removeItem(key);
  return null;
}

export function getSessionItem(key) {
  const value = localStorage.getItem(key);
  if (value !== null && value !== '') {
    return value;
  }
  return migrateFromSessionStorage(key);
}

export function setSessionItem(key, value) {
  localStorage.setItem(key, value);
  sessionStorage.removeItem(key);
}

export function removeSessionItem(key) {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
}

export function clearPersistedSession() {
  SESSION_KEYS.forEach(removeSessionItem);
}

export function getSessionModules() {
  try {
    const raw = getSessionItem(MODULES_KEY);
    if (!raw) {
      return [];
    }
    const modules = JSON.parse(raw);
    return Array.isArray(modules) ? modules : [];
  } catch {
    return [];
  }
}

export function isSessionStorageKey(key) {
  return SESSION_KEYS.includes(key);
}
